import { connect } from 'react-redux';

import { WixConnect } from 'shared/utils/wix-connect';

import { canShowMainItemTitle, canShowMainItemPublisher } from 'shared/selectors/app-settings';

import OverlayMemberOnlyBase from 'widget/components/player-overlay/_base-member-only-overlay';

import styles from './member-only.styl';


class OverlayMemberOnlyMobileBase extends OverlayMemberOnlyBase {

  get title() {
    if (!this.props.canShowMainItemTitle) {
      return null;
    }

    const titleText = this.titleText;

    if (!titleText) {
      return null;
    }

    return (
      <div styleName="title">
        <span styleName="title-text">
          {titleText}
        </span>
      </div>
    );
  }

  get buttons() {
    return (
      <div styleName="buttons">
        {this.playButton}
      </div>
    );
  }
}


@WixConnect(styles)
export class OverlayMemberOnlyMobileNoTitle extends OverlayMemberOnlyMobileBase {

  static displayName = 'OverlayMemberOnlyMobileNoTitle';

  get buttonStyleName() {
    return 'button simple-play-button';
  }

  get title() {
    return null;
  }

  get publisher() {
    return null;
  }
}


@connect(state => ({
  canShowMainItemTitle: canShowMainItemTitle(state),
  canShowMainItemPublisher: canShowMainItemPublisher(state),
}))
@WixConnect(styles)
export default class OverlayMemberOnlyMobile extends OverlayMemberOnlyMobileBase {
  static displayName = 'OverlayMemberOnlyMobile';

  get buttonStyleName() {
    return 'button simple-play-button';
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/mobile/member-only.js